import { Box, BoxProps } from "@mui/material";
import { toSxArray } from "src/utils/mui/sx/sx";

export interface IHoverCardProps extends BoxProps {
    href?: string;
}

export const HoverCard = ({ children, sx, ...props }: IHoverCardProps) => {
    return (
        <Box
            {...props}
            sx={[
                {
                    display: "flex",
                    padding: 2,
                    bgcolor: "white",
                    boxShadow: 2,
                    borderRadius: 1,
                    cursor: "pointer",
                    transition: "all 0.2s",
                    "&:hover": { boxShadow: 6, transform: "scale(1.02)", zIndex: 1 },
                    "&:active": { transform: "scale(1)" },
                },
                ...toSxArray(sx),
            ]}
        >
            {children}
        </Box>
    );
};
